/** @format */

import { actionTypes } from './actions'
import { actionTypes as signUserTypes } from '../auth/actions'

const initialState = {
  sidebarWidth: 200,
  isOpenSidebar: true,
  isLoading: false,
  errorMessage: undefined,
}

export const overlayReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.SET_STATUS_SIDEBAR_TRUE:
      return { ...state, isOpenSidebar: true }
    case actionTypes.SET_STATUS_SIDEBAR_FALSE:
      return { ...state, isOpenSidebar: false }
    case actionTypes.HANDLE_STATUS_SIDEBAR:
      return { ...state, isOpenSidebar: !state.isOpenSidebar }

    case signUserTypes.AUTH_SOCIAL_REQUEST:
    case signUserTypes.SIGN_IN_REQUEST:
    case signUserTypes.SIGN_UP_REQUEST:
      return { ...state, isLoading: true }

    case signUserTypes.AUTH_SOCIAL_SUCCESS:
    case signUserTypes.SIGN_UP_SUCCESS:
    case signUserTypes.SIGN_IN_SUCCESS:
      return { ...state, isLoading: false }

    case signUserTypes.AUTH_SOCIAL_ERROR:
    case signUserTypes.SIGN_IN_ERROR:
    case signUserTypes.SIGN_UP_ERROR:
    case signUserTypes.FORGOT_PASSWORD_ERROR:
      return { ...state, isLoading: false, errorMessage: payload.message }

    case actionTypes.CLEAR_ERROR_MESSAGE:
      return { ...state, errorMessage: '' }

    default:
      return state
  }
}
